export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_17.b1f1eadd.jpg";